/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { fractionDependencies } from './dependenciesFraction.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSumTransform } from '../../factoriesAny.js';
export var sumTransformDependencies = {
  bignumberDependencies: bignumberDependencies,
  fractionDependencies: fractionDependencies,
  addDependencies: addDependencies,
  typedDependencies: typedDependencies,
  createSumTransform: createSumTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSumTransform.generated.js
// module id = 1529
// module chunks = 0